import * as S from "../styles";

/* eslint-disable @typescript-eslint/no-unused-vars */
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid } from "@mui/material";
import { useEffect, useState } from "react";

import AutoCompleteMult from "@/components/hookForms/autoCompleteMult";
import CheckBox from "../../../../components/hookForms/checkbox";
import CloseIcon from "@mui/icons-material/Close";
import DatePickerMui from "../../../../components/hookForms/datePicker";
import IGenericResult from "../../../../interfaces/IGenericResult";
import IconButton from "@mui/material/IconButton";
import { format } from "date-fns";
import messages from "../../../../utils/messages";
import serviceRelatorio from "../../../../services/serviceRelatorio";
import serviceUsina from "../../../../services/serviceUsina";
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";
import { useHistory } from "react-router-dom";

export interface IDialogProps {
    open: boolean;
    onClose?: any;
}

export default function FaturasPendentes({ open, onClose }: IDialogProps) {
    const [usinaDataOptions, setUsinaDataOptions] = useState<IGenericResult[]>([]);
    const [disabled, setDisabled] = useState(false);

    const history = useHistory();

    const {
        control,
        handleSubmit,
        reset,
        formState: { errors },
    } = useForm({
        defaultValues: {
            idsUsinas: "",
            cicloFaturamento: "",
        },
    });

    useEffect(() => {
        setUsinaData();
    }, []);

    const setUsinaData = async () => {
        serviceUsina
            .getUsinas()
            .then((result) => {
                setUsinaDataOptions(result?.data);
            })
            .catch(() => {
                setUsinaDataOptions([]);
            });
    };

    const onSubmit = (values: any) => {
        setDisabled(true);

        let cicloFaturamento = new Date(values.cicloFaturamento);

        const newValues = {
            ...values,
            relatorioTipoID: 9,
            idsUsinas: values.idsUsinas ? values.idsUsinas.join(", ") : "",
            cicloFaturamento: values.cicloFaturamento ? format(cicloFaturamento, "yyyy-MM-01") : "",
        };

        delete newValues.redirecionar;

        serviceRelatorio
            .getRelatorioFaturaPendente(newValues)
            .then((result) => {
                if (result) {
                    onClose();
                    toast.success(messages.reportSucess);
                }
            })
            .catch(() => {
                toast.error(messages.reportError);
            })
            .finally(() => {
                setDisabled(false);
                if (values.redirecionar) {
                    history.push("/relatorios/listagemrelatorios");
                }
            });
    };

    return (
        <div>
            <Dialog
                maxWidth="md"
                fullWidth
                onClose={(_, reason) => {
                    if (reason !== "backdropClick") {
                        onClose();
                    }
                }}
                open={open}
            >
                <DialogTitle>
                    <S.Title>Gerar relatório: Faturas pendentes</S.Title>
                    <IconButton
                        aria-label="close"
                        onClick={() => {
                            reset();
                            onClose();
                        }}
                        sx={{
                            position: "absolute",
                            right: 8,
                            top: 8,
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <DialogContent dividers>
                        <Grid item xs={12}>
                            {disabled && (
                                <S.Loader>
                                    <img alt="Loading" src="/Loading.gif" width="40px" height="40px" />
                                </S.Loader>
                            )}
                        </Grid>

                        <Grid container spacing={2} display="flex" alignItems="center">
                            <Grid item xs={12} md={12}>
                                <AutoCompleteMult
                                    name="idsUsinas"
                                    label="Usinas"
                                    options={usinaDataOptions}
                                    control={control}
                                    error={errors}
                                />
                            </Grid>
                            <Grid item xs={12} md={12}>
                                <DatePickerMui
                                    name="cicloFaturamento"
                                    label="Ciclo de faturamento"
                                    format="MM/yyyy"
                                    view={["month", "year"]}
                                    control={control}
                                    error={errors}
                                />
                            </Grid>
                        </Grid>
                        <S.Spacing />
                        <Grid item xs={12} md={6}>
                            <CheckBox
                                name="redirecionar"
                                label="Redirecionar para a tela de relatório"
                                control={control}
                                error={errors}
                            />
                        </Grid>
                    </DialogContent>
                    <DialogActions style={{ display: "flex", justifyContent: "center", margin: "24px" }}>
                        <Button
                            style={{ width: "159px", height: "44px" }}
                            onClick={() => {
                                reset();
                                onClose();
                            }}
                            color="warning"
                            variant="contained"
                        >
                            Cancelar
                        </Button>
                        <Button
                            disabled={disabled}
                            style={{ width: "159px", height: "44px" }}
                            type="submit"
                            variant="contained"
                        >
                            Gerar
                        </Button>
                    </DialogActions>
                </form>
            </Dialog>
        </div>
    );
}
